import React from "react";

import SomethingWentTowrongIcon from "@/Components/Icons/SomethingWentTowrongIcon";

import { loadState } from "../localStorage";
// import { setAllPermissions, setIsAuthenticated, setSession } from '../reducers/session';
import store from "../store";
const ErrorBoundaryView = () => {
  const savedState = loadState();
  const initialState = savedState;
  const dispatch = store.dispatch;
  // useLayoutEffect(() => {
  //   if (initialState && initialState.session) {
  //     dispatch(setIsAuthenticated(true));
  //     dispatch(setAllPermissions(initialState.session.session.allPermissions));
  //     dispatch(setSession(initialState.session.session));
  //   }
  // }, []);
  return (
    <div className="ErrorBoundaryView_Wrapper select-none">
      <div className="flex min-h-screen w-full flex-col items-center justify-center gap-2">
        <SomethingWentTowrongIcon cls="drop-shadow" />
        <h1 className="text-[24px] font-semibold text-blue max-sm:text-center max-sm:text-[16px] md:text-[20px]">
          Oops Something went wrong!
        </h1>
        <p className="txt-black text-[18px] font-medium max-sm:text-center max-sm:text-[12px] md:text-[16px]">
          We apologize for the inconvenience. It seems something didn't go as
          planned.
        </p>
        <div className="mt-4">
          <button
            className="transition-linear rounded-[8px] border-2 border-primary bg-primary px-14 py-2 text-white hover:bg-white hover:text-primary"
            onClick={() => {
              window.location.reload();
            }}
          >
            Refresh
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundaryView;
